declare const __BUILD_TAG__: string;

/** Short git hash penanda build, untuk memastikan versi yang dimainkan. */
export const BUILD_TAG: string =
  typeof __BUILD_TAG__ !== 'undefined' ? __BUILD_TAG__ : 'dev';
